var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreakFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 57,
    viewBox: "0 0 43 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3543 56.25C9.5076 55.2632 -7.45273 44.6053 3.59118 17.7632C4.38002 22.5 7.20676 25 8.52152 25.6579C7.20677 18.4211 8.71873 3.15789 25.2846 0C22.9838 1.31579 19.9599 5.92105 26.2707 13.8158C32.5815 21.7105 34.8166 28.9474 35.1452 31.5789C37.4129 28.9852 41.1494 22.3014 38.2354 16.0625C38.1918 15.9717 38.1478 15.8807 38.1034 15.7895C38.1489 15.8804 38.1928 15.9714 38.2354 16.0625C52.1711 45.0701 31.1671 56.25 20.3543 56.25Z",
    fill: "#F6D169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5948 56.2501C16.5104 55.8037 8.56024 50.9823 13.7371 38.8394C14.1068 40.9823 15.4319 42.1132 16.0482 42.4109C15.4319 39.137 16.1406 32.2323 23.9059 30.8037C22.8274 31.3989 21.4099 33.4823 24.3681 37.0537C27.3263 40.6251 28.374 43.8989 28.528 45.0894C29.591 43.9161 31.3425 40.8924 29.9766 38.0701C29.9561 38.029 29.9355 37.9878 29.9147 37.9466C29.936 37.9877 29.9566 38.0289 29.9766 38.0701C36.5089 51.1926 26.6633 56.2501 21.5948 56.2501Z",
    fill: "#FFE9AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreakFire);
export default __webpack_public_path__ + "static/media/streak_fire.f10d636b603569f18aa205713625c493.svg";
export { ForwardRef as ReactComponent };